export const SET_USERS = 'SET_USERS';
export const SET_USER_ID = 'SET_USER_ID';
export const REMOVE_USER_ID = 'REMOVE_USER_ID';
export const SET_USER = 'SET_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const SET_INSTRUCTORS = 'SET_INSTRUCTORS';
export const SET_USER_BY_ID = 'SET_USER_BY_ID';
export const UNSTAGE_USER = 'UNSTAGE_USER';


// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js